import { createStore } from 'vuex'
import login from '@/store/modules/login'
import user from '@/store/modules/user'
import permission from '@/store/modules/permission'
import getters from '@/store/getters'
export default createStore({
  modules: {
    login,
    user,
    permission
  },
  getters
})
